{
  "08f13c0eaa454ceb": "Download for Android",
  "0cf3a3f729944fa0": "Request Sent",
  "0d0e02e4ceed56d5": "Expand timeline",
  "19766ed6ccb2f4a3": "Cancel",
  "1cd58655ba2331c9": "Error loading document",
  "2074af6eeb2b3275": "Download the Clipboard Workplace app to view your schedule, post shifts, and message your workers on the go.",
  "2b6a38b89f9c7b30": "Next day",
  "3b7ea51793e9d906": "Clear search",
  "43d6f08e4edb5431": "Local time: {{localTime}}",
  "51ade6c018ded413": "No current notifications",
  "59ebe97eedd6795e": "Edit time",
  "5fbc1e7e7e83b837": "Collapse timeline",
  "6248346eae8d0df7": "Increase quantity",
  "685e43d81887725c": "{{currentStep}} of {{totalSteps}}",
  "6c15c542ce67f0a9": "Decrease quantity",
  "71139c3ae28e7d90": "Set Limit",
  "7587b4b51fb544fa": "This week has already ended",
  "7707b94233940ee1": "Download for iOS",
  "788011833a5a0f22": "Notifications",
  "7a0d06d516580b7f": "Close drawer",
  "7d9eb7acb13e2462": "Close",
  "916d8ebfe068b43a": "Edit Limit",
  "926cc946fedafbf5": "Error Loading Notifications. Please try again later.",
  "93483c938871b25a": "Weekly limit",
  "96f2f0811df88d8f": "pm",
  "999d5198e33dfdb4": "Dismiss coachmark",
  "99af6606ff9d6cd5": "Menu",
  "ab6db599234d2636": "am",
  "b37c7879f6c359f6": "Not recorded",
  "c8df66c5fe3f97d0": "Close dialog",
  "d6eafe8235910042": "Download",
  "df0fe79898ef413e": "Print",
  "e4a1e89ee1db53ce": "Previous day",
  "ea61bc15688d1e48": "Copied!",
  "eb0c3ed107b24c4b": "No weekly limit",
  "efd29d8c54d0a8ff": "Take Clipboard with you",
  "efe7287d10ef5fe2": "Request Increase"
}
